import { useEffect } from "react";
import { useRevalidator } from "react-router";

/**
 * Reruns the active loaders when the page becomes visible again: back from
 * another tab, or an installed web app reopened after sitting in the
 * background. A revalidation doesn't touch useNavigation(), so the data
 * refreshes in place without the navigation progress bar. Offline it waits:
 * a failed loader would swap the page for its error screen.
 */
export function useRevalidateOnVisible() {
  const { revalidate } = useRevalidator();

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible" && navigator.onLine) revalidate();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, [revalidate]);
}
